<template>
  <div>
    <veaDialog
      :title="title"
      class="reCHForm"
      :show.sync="show"
      :before-close="closeDialog"
      :showBtn="false"
    >
      <el-table
        ref="table"
        border
        stripe
        highlight-current-row
        :data="tableData"
        tooltip-effect="dark"
        header-row-class-name="table_header"
        :header-row-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        height="420"
      >
        <el-table-column
          v-for="(item, i) in th"
          :key="i"
          :label="item.chnname"
          :width="item.width"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isEdit && false">
              <el-switch
                v-if="item.switch"
                :disabled="item.disabled"
                v-model="scope.row[item.fieldname]"
                active-color="#1890FF"
                inactive-color="#999999"
              ></el-switch>
              <el-select
                clearable
                v-else-if="item.select"
                v-model="scope.row[item.fieldname]"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="item in tboptions[item.op || item.fieldname]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                v-else-if="item.number"
                v-model="scope.row[item.fieldname]"
                oninput="value=value.replace(/\D/g,'')"
              />
              <el-date-picker
                v-else-if="item.datetime"
                type="date"
                placeholder="选择日期"
                v-model="scope.row[item.fieldname]"
                style="width: 100%;"
              ></el-date-picker>
              <el-input v-else v-model="scope.row[item.fieldname]" />
            </template>

            <span v-else>{{
              item.switch
                ? scope.row[item.fieldname]
                  ? '是'
                  : '否'
                : scope.row[item.fieldname]
            }}</span>
          </template>
        </el-table-column>
        <!-- 查看 -->
        <el-table-column
          :label="'查看'"
          width="100"
          fixed="right"
          class-name="operateColumn"
        >
          <template slot-scope="scope">
            <span
              class="table_operate"
              @click="tableOperate(scope.$index, scope.row, 'showDetail')"
            >
              点击查看明细
            </span>
          </template>
        </el-table-column>
      </el-table>
    </veaDialog>
    <veaDialog
      :title="title"
      class="Tabledetail"
      :show.sync="showdetail"
      :before-close="closeDialog2"
      :showBtn="false"
    >
      <el-table
        ref="table"
        border
        stripe
        highlight-current-row
        :data="tableData2"
        tooltip-effect="dark"
        header-row-class-name="table_header"
        :header-row-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        height="420"
      >
        <el-table-column
          v-for="(item, i) in th2"
          :key="i"
          :label="item.chnname"
          :width="item.width"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isEdit && false">
              <el-switch
                v-if="item.switch"
                :disabled="item.disabled"
                v-model="scope.row[item.fieldname]"
                active-color="#1890FF"
                inactive-color="#999999"
              ></el-switch>
              <el-select
                clearable
                v-else-if="item.select"
                v-model="scope.row[item.fieldname]"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="item in tboptions[item.op || item.fieldname]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                v-else-if="item.number"
                v-model="scope.row[item.fieldname]"
                oninput="value=value.replace(/\D/g,'')"
              />
              <el-date-picker
                v-else-if="item.datetime"
                type="date"
                placeholder="选择日期"
                v-model="scope.row[item.fieldname]"
                style="width: 100%;"
              ></el-date-picker>
              <el-input v-else v-model="scope.row[item.fieldname]" />
            </template>

            <span v-else>{{
              item.switch
                ? scope.row[item.fieldname]
                  ? '是'
                  : '否'
                : scope.row[item.fieldname]
            }}</span>
          </template>
        </el-table-column>
        <!-- 查看 -->
        <el-table-column
          :label="'查看'"
          width="100"
          fixed="right"
          class-name="operateColumn"
        >
          <template slot-scope="scope">
            <span
              class="table_operate"
              @click="tableOperate(scope.$index, scope.row, 'showinfo')"
            >
              点击查看详细
            </span>
          </template>
        </el-table-column>
      </el-table>
    </veaDialog>
     <!-- 表单 -->
    <veaDialog
      :title="title"
      class="reForm"
      :show.sync="showre"
      :before-close="closeDialog3"
      :showBtn="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发类别">
              <!-- <el-select
                clearable
                filterable
                v-model="form.khtype"
                placeholder="请选开发类别"
              >
                <el-option v-for="o in khtype" :key="o" :label="o" :value="o">
                </el-option>
              </el-select> -->
              <el-input v-model="form.khtype" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.qwdate"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开发主题">
          <el-input v-model="form.title" placeholder="请输入"> </el-input>
        </el-form-item>

        <el-form-item label="开发内容详细说明">
          <!-- <el-input v-model="form.contant" type="textarea" rows="20"></el-input> -->
          <UE :defaultMsg="form.contant" :config="config" ref="ue"></UE>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" rows="20"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发状态">
              <!-- <el-select
                clearable
                filterable
                v-model="form.status"
                placeholder="请选开发类别"
              >
                <el-option v-for="o in status" :key="o" :label="o" :value="o">
                </el-option>
              </el-select> -->
              <el-input v-model="form.status" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开发负责人" required >
              <el-input v-model="form.fzr" placeholder="请输入"> </el-input>
                <!-- <el-select
            clearable
            filterable
            v-model="form.fzr"
            placeholder="开发负责人"
          >
            <el-option v-for="o in fzrList" :key="o" :label="o" :value="o">
            </el-option>
          </el-select> -->
          
            </el-form-item>
           
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发预计完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.yjdate"
                style="width: 100%;"
                :disabled="['黄桥','罗宇庆'].indexOf(userInfo.name)==-1"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.sjdate"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开发备注说明">
          <el-input v-model="form.remark2" type="textarea" rows="20"></el-input>
        </el-form-item>
      </el-form>
    </veaDialog>
  </div>
</template>

<script>
import { parseTime } from '@/utils'
import { Query_tpr_erkaiZB } from '@api/api.js'
import UE from '@components/ue.vue'
export default {
  components: {
    UE
  },
  props: {
    tableData: {
      // 表格值
      type: Array,
      default: [{}]
    },
    query: {
      // 周报月报参数
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      config: {
        // UEDITOR_HOME_URL: '/static/ueditor/',
        initialFrameWidth: null,
        initialFrameHeight: 700
      },
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      show: false,
      showdetail: false,
      th: [
        {
          chnname: '姓名',
          fieldname: 'fzr'
        },
        {
          chnname: '任务总数',
          fieldname: 'rwnum1'
        },
        {
          chnname: '已完成数',
          fieldname: 'wcnum'
        },
        {
          chnname: '未完成数',
          fieldname: 'wwc'
        },
        {
          chnname: '逾期完成数',
          fieldname: 'yq'
        },
        {
          chnname: '完成率',
          fieldname: 'wcl'
        }
      ],
      th2: [
        {
          chnname: '项目名称',
          fieldname: 'mautoid',
          width: '100',
          select: true
        },
        {
          chnname: '开发类别',
          fieldname: 'khtype',
          width: '100'
        },
        {
          chnname: '提出人',
          fieldname: 'crman',
          width: '100'
        },
        {
          chnname: '提出日期',
          fieldname: 'crdate',
          width: '120',
          sortable: true
        },
        {
          chnname: '开发主题',
          fieldname: 'title',
          width: '300'
        },
        // {
        //   chnname: '开发内容详细说明',
        //   fieldname: 'contant',
        //   width: '200'
        // },

        {
          chnname: '期望完成日期',
          fieldname: 'qwdate',
          width: '140',
          sortable: true
        },
        {
          chnname: '进度状态',
          fieldname: 'jdzt',
          width: '100'
        },
        {
          chnname: '开发状态',
          fieldname: 'status',
          width: '100'
        },
        {
          chnname: '开发负责人',
          fieldname: 'fzr',
          width: '100'
        },
        {
          chnname: '开发预计完成日期',
          fieldname: 'yjdate',
          width: '160',
          sortable: true
        },
        {
          chnname: '实际完成日期',
          fieldname: 'sjdate',
          width: '140',
          sortable: true
        },
        {
          chnname: '开发备注说明',
          fieldname: 'remark2',
          width: '140'
        },
        {
          chnname: '备注',
          fieldname: 'remark',
          width: '60'
        }
      ],
      tableData2: [],
       showre: false,
       form: {
        autoid: '0',
        mautoid: '0',
        khtype: '',
        title: '',
        contant: '',
        qwdate: parseTime(new Date(), '{y}-{m}-{d}'),
        yjdate: parseTime(new Date(), '{y}-{m}-{d}'),
        sjdate: null,
        status: '',
        fzr: '',
        remark: '',
        remark2: '',
        isactive: 1,
        isadd: 1
      },
    }
  },
  computed: {
    title() {
      let s = ''
      if (this.query.kftype == 1) {
        s = '开发周报'
      } else {
        s = '月份:' + this.query.yymm + ' 开发月报'
      }
      return s
    }
  },
  methods: {
    closeDialog() {
      this.show = false
    },
    closeDialog2() {
      this.showdetail = false
    },
    closeDialog3() {
      this.showre = false
    },
    // 表格 操作方法
    tableOperate(index, row, type) {
      // 编辑
      if (type == 'showDetail') {
        let { kftype, bd, ed, yymm } = this.query
        Query_tpr_erkaiZB({ kftype, bd, ed, yymm, fzr: row.fzr })
          .then(res => {
            res.list.forEach(e => {
              e.yjdate = e.yjdate ? e.yjdate.split('T')[0] : ''
              e.sjdate = e.sjdate ? e.sjdate.split('T')[0] : ''
              e.qwdate = e.qwdate ? e.qwdate.split('T')[0] : ''
              e.crdate = e.crdate ? e.crdate.split('T')[0] : ''
            })
            this.tableData2 = res.list
          })
          .finally(() => (this.showdetail = true))
      }
      else if (type =='showinfo'){
          this.showre = true
          this.form = row
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-dialog__wrapper.reCHForm {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(1200px, 700px);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      .el-table {
        .table_operate {
          cursor: pointer;
          color: blue;
        }
      }
    }
  }
}
.el-dialog__wrapper.Tabledetail {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(90vw, 700px);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      .el-table {
        .table_operate {
          cursor: pointer;
          color: blue;
        }
      }
    }
  }
}

.reForm {
  /deep/ .el-dialog {
    @include wh(99vw, 99vh);

    .el-dialog__body {
      padding: 10px;
      height: 100%;
      overflow-y: scroll;
    }
  }
}
/deep/ .el-form-item {
  .el-form-item__label {
    font-weight: bold;
  }
}
</style>
